import React, {useEffect, useState} from "react";
import {socket} from "../socket";
import {GameMap} from "./Map";
import {MapContainer, Marker, Popup, TileLayer, useMapEvents} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';


export default function GameMasterInterface() {
    const [players, setPlayers] = useState([]);
    const [gameState, setGageState] = useState({
        gameMasterId: null,
        players: new Map(),
        isGameStarted: false,
        rolesDefined: false,
        GpsDefined: false,
        questionsDefined: false,
        questions: [],
        reunionAsked: false,
        endDate: null,
        userRoles: {loup: 0, villageois: 0, chasseur: 0, voleur: 0, voyante: 0, sorciere: 0, petiteFille: 0},
    });
    const [points, setPoints] = React.useState([]); // {lat: 48.584385, lng: 2.600841}
    const [duration, setDuration] = React.useState(30);
    const [manhuntDuration, setManhuntDuration] = React.useState(2);

    const [roleQuantities, setRoleQuantities] = useState({
        loup: 0,
        villageois: 0,
        chasseur: 0,
        petiteFille: 0
    });

    const [showEndGameModal, setShowEndGameModal] = useState(false);
    const [endGameMessage, setEndGameMessage] = useState("");
    const [countdown, setCountdown] = useState(5);

    const [questionSets, setQuestionSets] = useState([]);
    const [selectedQuestionSet, setSelectedQuestionSet] = useState('');
    const [saveSetName, setSaveSetName] = useState('');
    const [showSaveModal, setShowSaveModal] = useState(false);

    const [questions, setQuestions] = useState([]);

    const LocationFinderDummy = () => {
        const map = useMapEvents({
            click(e) {
                const {latlng} = e;
                setPoints((prevPoints) => [...prevPoints, {lat: latlng.lat, lng: latlng.lng}]);
            },
        });
        return null;
    };

    useEffect(() => {
        socket.emit('get_question_sets', (sets) => {
            setQuestionSets(sets);
        });

        // Écouter les réponses du serveur
        socket.on('question_set_saved', (response) => {
            if (response.success) {
                alert('Questions sauvegardées avec succès');
                // Rafraîchir la liste
                socket.emit('get_question_sets', (sets) => {
                    setQuestionSets(sets);
                });
            } else {
                alert(`Erreur: ${response.message}`);
            }
        });

        return () => {
            socket.off('question_set_saved');
        };
    }, []);

    useEffect(() => {
        socket.on('game_ended', (result) => {
            console.log("Partie terminée:", result);
            setEndGameMessage(result.message || "La partie est terminée");
            setShowEndGameModal(true);

            // Démarrer un compte à rebours
            let count = 5;
            setCountdown(count);

            const intervalId = setInterval(() => {
                count--;
                setCountdown(count);

                if (count <= 0) {
                    clearInterval(intervalId);
                    // Rediriger vers la page d'accueil
                    window.location.href = '/';
                }
            }, 1000);

            return () => clearInterval(intervalId);
        });

        return () => {
            socket.off('game_ended');
        };
    }, []);

    useEffect(() => {

        socket.emit('get-game-info');

        socket.on('game-info', (gameInfo) => {
            console.log(gameInfo);
            setGageState(gameInfo);
        });

        socket.on('players-update', (updatedPlayers) => {
            console.log(updatedPlayers.filter(n => n));
            setPlayers(updatedPlayers.filter(n => n));
        });

        socket.on('error', (error) => {
            alert(error.message);
        });

        socket.on('roles-set-success', (response) => {
            // Optionnel : afficher un message de succès
            console.log(response.message);
        });

        socket.on('questions-set-success', (response) => {
            // Optionnel : afficher un message de succès
            console.log(response.message);
        });

        socket.on('reunion-asked', () => {
            socket.emit('get-game-info');
        });

        socket.on('manhunt-error', (e) => {
            alert(e && e.message ? e.message : 'Impossible de déclencher la chasse à l\'homme');
        });


        return () => {
            socket.off('players-update');
            socket.off('game-info');
            socket.off('error');
            socket.off('roles-set-success');
            socket.off('manhunt-error');

        };
    }, []);

    // Fonction pour sauvegarder les questions actuelles
    const handleSaveQuestions = () => {
        setShowSaveModal(true);
    };

// Fonction pour confirmer la sauvegarde
    const confirmSaveQuestions = () => {
        if (!saveSetName.trim()) {
            alert('Veuillez entrer un nom pour cet ensemble de questions');
            return;
        }

        socket.emit('save_question_set', {
            name: saveSetName,
            questions: questions
        }, (response) => {
            if (response.success) {
                alert('Questions sauvegardées avec succès');
                setShowSaveModal(false);
                setSaveSetName('');

                // Rafraîchir la liste
                socket.emit('get_question_sets', (sets) => {
                    setQuestionSets(sets);
                });
            } else {
                alert(`Erreur: ${response.message}`);
            }
        });
    };

// Fonction pour charger un ensemble de questions
    const handleLoadQuestions = () => {
        if (!selectedQuestionSet) {
            alert('Veuillez sélectionner un ensemble de questions');
            return;
        }

        socket.emit('load_question_set', selectedQuestionSet, (response) => {
            if (response.success) {
                setQuestions(response.questions);
                alert('Questions chargées avec succès');
            } else {
                alert(`Erreur: ${response.message}`);
            }
        });
    };

// Fonction pour supprimer un ensemble de questions
    const handleDeleteQuestionSet = () => {
        if (!selectedQuestionSet) {
            alert('Veuillez sélectionner un ensemble de questions');
            return;
        }
        if (window.confirm(`Êtes-vous sûr de vouloir supprimer l'ensemble "${selectedQuestionSet}" ?`)) {
            socket.emit('delete_question_set', selectedQuestionSet, (response) => {
                if (response.success) {
                    alert('Ensemble de questions supprimé');
                    setSelectedQuestionSet('');

                    // Rafraîchir la liste
                    socket.emit('get_question_sets', (sets) => {
                        setQuestionSets(sets);
                    });
                } else {
                    alert(`Erreur: ${response.message}`);
                }
            });
        }
    };

    // Remove a point from the list
    const handleMarkerClick = (index) => {
        setPoints((prevPoints) => prevPoints.filter((_, i) => i !== index));
    };

    // Validate and send points to the server
    const handleValidatePoints = () => {
        if (socket) {
            socket.emit('save_gps_points', points);
        }
    };

    const totalRoles = Object.values(roleQuantities).reduce((a, b) => a + b, 0);

    // Fonction pour gérer les changements de quantité avec vérification
    const handleRoleQuantityChange = (role, value) => {
        const newValue = parseInt(value) || 0;
        const otherRolesTotal = Object.entries(roleQuantities)
            .filter(([r]) => r !== role)
            .reduce((sum, [, qty]) => sum + qty, 0);

        // Vérifie que le nouveau total ne dépasse pas le nombre de joueurs
        if (otherRolesTotal + newValue <= players.length) {
            setRoleQuantities(prev => ({
                ...prev,
                [role]: newValue
            }));
        }
    };

    const handleValidateQuestions = () => {
        if (socket) {
            socket.emit('set-questions', questions);
        }
    };

    const handleQuestionAnswerChange = (index, value) => {
        questions[index].answer = value;
        setQuestions(prev => [...prev]);
    }

    const handleQuestionDelete = (index) => {
        setQuestions(prev => prev.filter((_, i) => i !== index));
    }

    const handleQuestionChange = (index, value) => {
        questions[index].question = value;
        setQuestions(prev => [...prev]);
    }

    // Fonction pour valider les rôles
    const handleRolesSubmit = () => {
        // Vérifie que le total des rôles correspond exactement au nombre de joueurs
        if (totalRoles === players.length) {
            socket.emit('set-roles', roleQuantities);
            handleDurationSubmit();
        }

    };

    const initServer = () => {
        socket.emit('restart-server');
        alert('Initialisation du serveur, reboot en cours ...');
    }

    const handleDurationSubmit = () => {
        socket.emit('set-duration', duration);
        socket.emit('set-manhunt-duration', manhuntDuration);
    };

    // Fonction pour forcer la récupération des coordonnées GPS
    const handleForceGPSUpdate = () => {
        socket.emit('force-gps-update');
        alert('Demande de mise à jour GPS envoyée à tous les joueurs');
    };

    console.log(players);
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-black text-gray-100 p-8">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-4xl font-extrabold mb-6 text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-red-500 to-purple-500 drop-shadow-lg">
                    Interface Maître du Jeu
                </h1>
                <div className="space-y-6">
                    {gameState.isGameStarted && (
                        <div
                            className="bg-gray-900/70 border border-red-600/60 rounded-3xl shadow-[0_20px_60px_-15px_rgba(139,0,139,0.6)] px-6 py-4 text-center">
                            <h2 className="text-2xl font-semibold text-purple-300">
                                Joueurs connectés : {players.length}
                            </h2>
                        </div>
                    )}

                    {gameState.isGameStarted && players.length > 0 && (
                        <div
                            className="overflow-hidden rounded-3xl border border-purple-800 shadow-[0_20px_70px_-30px_rgba(128,0,128,0.9)]">
                            <GameMap isGameMaster={true} players={players} markers={[]}/>
                        </div>
                    )}

                    {showEndGameModal && (
                        <div
                            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur">
                            <div
                                className="bg-gradient-to-b from-gray-900 via-gray-950 to-black p-10 rounded-3xl border-4 border-purple-700 shadow-[0_25px_80px_-25px_rgba(128,0,128,0.8)] max-w-lg w-full">
                                <h2 className="text-3xl font-bold mb-6 text-center text-purple-300">
                                     Fin de la partie
                                </h2>
                                <p className="mb-6 text-gray-200 text-center text-lg leading-relaxed">
                                    {endGameMessage}
                                </p>
                                <div className="mb-6 bg-gray-900/70 rounded-2xl border border-purple-700 p-5">
                                    <h3 className="font-semibold mb-3 text-purple-200 text-xl text-center">
                                        Résumé de la partie
                                    </h3>
                                    <ul className="space-y-1 text-gray-300">
                                        <li> Joueurs : <span
                                            className="text-purple-300 font-semibold">{players.length}</span></li>
                                        <li> Loups : <span
                                            className="text-red-400 font-semibold">{players.filter(p => p.role === 'loup').length}</span>
                                        </li>
                                        <li> Survivants : <span
                                            className="text-green-400 font-semibold">{players.filter(p => p.alive).length}</span>
                                        </li>
                                        <li> Durée : <span
                                            className="text-purple-300 font-semibold">{gameState.duration} minutes</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                    {(!gameState.rolesDefined || gameState.isGameStarted) && (
                        <div className="mt-6">
                            <h3 className="text-lg font-semibold mb-3 text-purple-200">Liste des
                                joueurs</h3>
                            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                                {players.map((player, index) => (
                                    <div
                                        key={player.id || index}
                                        className="group bg-gradient-to-b from-gray-900 via-gray-950 to-black border border-purple-800 rounded-3xl p-5 shadow-[0_18px_60px_-25px_rgba(128,0,128,0.8)] transition-transform duration-300 hover:-translate-y-1 hover:border-red-600"
                                    >
                                        <div className="flex items-center justify-between mb-2">
                                            <h4 className="text-xl font-semibold text-purple-300">
                                                {player.name || 'Inconnu'}
                                            </h4>
                                            <span
                                                className={`text-sm font-medium px-3 py-1 rounded-full ${player.alive ? 'bg-green-600/30 text-green-300 border border-green-500/60' : 'bg-red-700/30 text-red-300 border border-red-600/60'}`}>
                                                            {player.alive ? 'Vivant' : 'Mort'}
                                                        </span>
                                        </div>
                                        <div className="space-y-2 text-gray-300 text-sm">
                                            <p className="flex justify-between"><span
                                                className="text-purple-200">Latitude :</span>
                                                <span>{player.position?.lat?.toFixed(6) || 'N/A'}</span></p>
                                            <p className="flex justify-between"><span
                                                className="text-purple-200">Longitude :</span>
                                                <span>{player.position?.lng?.toFixed(6) || 'N/A'}</span></p>
                                            <p className="flex justify-between"><span
                                                className="text-purple-200">Rôle :</span> <span
                                                className="text-red-300 font-semibold">{player.role || 'N/A'}</span>
                                            </p>
                                            <p className="flex justify-between"><span
                                                className="text-purple-200">état :</span>
                                                <span>{player.state || 'N/A'}</span></p>
                                            <p className="flex justify-between"><span
                                                className="text-purple-200">étape :</span>
                                                <span>{player.etape}</span></p>
                                        </div>
                                        <div className="flex gap-2 mt-4">
                                            <button
                                                onClick={() => socket.emit('alive', {playerId: player.id})}
                                                className="flex-1 px-3 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl shadow hover:from-green-500 hover:to-green-600 transition"
                                            >
                                                Ressusciter
                                            </button>
                                            <button
                                                onClick={() => socket.emit('dead', {name: player.name})}
                                                className="flex-1 px-3 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-xl shadow hover:from-red-500 hover:to-red-600 transition"
                                            >
                                                Tuer
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                {players.length === 0 && (
                                    <div className="col-span-full text-center text-gray-400 italic">
                                        Aucun joueur connecté pour le moment.
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {!gameState.rolesDefined && (
                        <div
                            className="mb-8 bg-gradient-to-b from-gray-900 via-gray-950 to-black p-6 rounded-3xl border border-purple-800 shadow-[0_20px_70px_-30px_rgba(128,0,128,0.9)]">
                            <h2 className="text-2xl font-semibold mb-4 text-purple-200">Définition des
                                rôles</h2>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                {Object.entries(roleQuantities).map(([role, quantity]) => (
                                    <div key={role}
                                         className="flex flex-col bg-gray-900/60 rounded-2xl border border-purple-700/60 p-4 shadow-inner">
                                        <label
                                            className="mb-2 capitalize text-purple-200 font-semibold tracking-wide">
                                            {role}
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            max={players.length - (totalRoles - quantity)}
                                            value={quantity}
                                            onChange={(e) => handleRoleQuantityChange(role, e.target.value)}
                                            className="border border-purple-700/60 bg-gray-950 text-gray-100 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600"
                                        />
                                    </div>
                                ))}
                            </div>

                            <h2 className="text-2xl font-semibold mt-8 mb-4 text-purple-200">Définition
                                de la durée</h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div
                                    className="flex flex-col bg-gray-900/60 rounded-2xl border border-purple-700/60 p-4">
                                    <label className="mb-2 text-purple-200 font-semibold">Durée de la
                                        partie (minutes)</label>
                                    <input
                                        type="number"
                                        min="1"
                                        max="100"
                                        value={duration}
                                        onChange={(e) => setDuration(e.target.value)}
                                        className="border border-purple-700/60 bg-gray-950 text-gray-100 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600"
                                    />
                                </div>
                                <div
                                    className="flex flex-col bg-gray-900/60 rounded-2xl border border-red-700/60 p-4">
                                    <label className="mb-2 text-red-300 font-semibold">Durée chasse à
                                        l'homme (minutes)</label>
                                    <input
                                        type="number"
                                        min="1"
                                        max="30"
                                        value={manhuntDuration}
                                        onChange={(e) => setManhuntDuration(e.target.value)}
                                        className="border border-red-700/60 bg-gray-950 text-gray-100 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-600"
                                    />
                                </div>
                            </div>

                            <div
                                className="mt-6 bg-gray-900/60 rounded-2xl border border-purple-700/60 p-5">
                                <p className={`mb-4 text-lg font-semibold ${totalRoles > players.length ? 'text-red-400' : totalRoles < players.length ? 'text-yellow-400' : 'text-green-400'}`}>
                                    Total des rôles : {totalRoles} / {players.length} joueurs
                                </p>
                                <div className="flex flex-wrap gap-3">
                                    <button
                                        onClick={initServer}
                                        disabled={totalRoles !== players.length}
                                        className={`flex-1 min-w-[180px] px-4 py-3 rounded-xl font-semibold transition ${totalRoles === players.length ? 'bg-gradient-to-r from-red-600 to-purple-700 text-white hover:from-red-500 hover:to-purple-600 shadow-lg' : 'bg-gray-700 text-gray-500 cursor-not-allowed'}`}
                                    >
                                        Initier le serveur
                                    </button>
                                    <button
                                        onClick={handleRolesSubmit}
                                        disabled={totalRoles !== players.length}
                                        className={`flex-1 min-w-[180px] px-4 py-3 rounded-xl font-semibold transition ${totalRoles === players.length ? 'bg-gradient-to-r from-green-600 to-green-700 text-white hover:from-green-500 hover:to-green-600 shadow-lg' : 'bg-gray-700 text-gray-500 cursor-not-allowed'}`}
                                    >
                                         Valider les rôles
                                    </button>
                                </div>
                                {totalRoles !== players.length && (
                                    <p className="mt-3 text-sm text-red-400">
                                        {totalRoles < players.length
                                            ? `Il manque ${players.length - totalRoles} rôle(s) à attribuer`
                                            : `Il y a ${totalRoles - players.length} rôle(s) en trop`}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}

                    {gameState.rolesDefined && !gameState.GpsDefined && (
                        <section className="relative overflow-hidden rounded-3xl border border-purple-900/70 bg-gradient-to-br from-gray-950 via-gray-900 to-black p-8 shadow-[0_40px_120px_-45px_rgba(128,0,128,0.85)]">
                            <div className="pointer-events-none absolute -top-24 -right-20 h-64 w-64 rounded-full bg-purple-600/30 blur-3xl" />
                            <div className="pointer-events-none absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-red-500/20 blur-3xl" />
                            <div className="relative z-10 flex flex-col gap-8 lg:flex-row">
                                <div className="flex-1 space-y-6">
                                    <div className="space-y-3">
                                        <span className="inline-flex items-center gap-2 rounded-full border border-purple-500/40 bg-purple-500/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.3em] text-purple-200">
                                            Phase GPS
                                        </span>
                                        <h2 className="text-3xl font-bold text-purple-100">
                                            Définissez les coordonnées GPS
                                        </h2>
                                        <p className="max-w-xl text-sm leading-relaxed text-gray-400">
                                            Cliquez sur la carte pour placer les points d'intérêt que les joueurs devront rejoindre. Supprimez un marqueur en cliquant dessus s'il n'est plus nécessaire.
                                        </p>
                                    </div>
                                    <div className="flex flex-wrap items-center gap-4">
                                        <div className="flex items-center gap-3 rounded-2xl border border-purple-700/60 bg-black/40 px-5 py-4 shadow-inner">
                                            <div className="text-4xl font-bold text-purple-300">{points.length}</div>
                                            <div className="text-xs uppercase tracking-[0.25em] text-gray-400">
                                                Point{points.length > 1 ? 's' : ''}<br />
                                                sélectionné{points.length > 1 ? 's' : ''}
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-3 rounded-2xl border border-purple-700/40 bg-black/40 px-5 py-4">
                                            <span className="relative flex h-3 w-3">
                                                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400/60 opacity-75" />
                                                <span className="relative inline-flex h-3 w-3 rounded-full bg-green-400" />
                                            </span>
                                            <span className="text-sm text-gray-300">
                                                Interagissez directement avec la carte pour ajouter ou retirer des zones.
                                            </span>
                                        </div>
                                    </div>
                                    <div className="relative overflow-hidden rounded-3xl border border-purple-800/80 shadow-[0_30px_100px_-50px_rgba(128,0,128,0.85)]">
                                        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-purple-500/10 via-transparent to-transparent" />
                                        <div className="h-[460px]">
                                            <MapContainer
                                                center={players[0]?.position || [48.862725, 2.287592]}
                                                zoom={15}
                                                style={{height: '100%', width: '100%'}}
                                            >
                                                <LocationFinderDummy />
                                                <TileLayer
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                />
                                                {points.map((point, index) => (
                                                    <Marker
                                                        key={index}
                                                        position={[point.lat, point.lng]}
                                                        eventHandlers={{
                                                            click: () => handleMarkerClick(index),
                                                        }}
                                                    >
                                                        <Popup>
                                                            Point {index + 1}: {point.lat.toFixed(5)}, {point.lng.toFixed(5)}
                                                        </Popup>
                                                    </Marker>
                                                ))}

                                                {players.map((player, index) => (
                                                    <Marker
                                                        key={index}
                                                        position={player.position}
                                                    >
                                                        <Popup>
                                                            Joueur {index + 1}
                                                        </Popup>
                                                    </Marker>
                                                ))}
                                            </MapContainer>
                                        </div>
                                    </div>
                                </div>
                                <aside className="w-full space-y-6 lg:w-[360px]">
                                    <div className="rounded-2xl border border-purple-800/60 bg-black/50 p-6 shadow-[0_25px_80px_-50px_rgba(128,0,128,0.85)]">
                                        <h3 className="text-lg font-semibold text-purple-200">Instructions rapides</h3>
                                        <ul className="mt-4 space-y-3 text-sm text-gray-300">
                                            <li className="flex items-start gap-3">
                                                <span className="mt-1 h-2 w-2 rounded-full bg-purple-400" />
                                                <span>Cliquez sur la carte pour ajouter un marqueur GPS.</span>
                                            </li>
                                            <li className="flex items-start gap-3">
                                                <span className="mt-1 h-2 w-2 rounded-full bg-purple-400" />
                                                <span>Sélectionnez un marqueur existant pour le retirer instantanément.</span>
                                            </li>
                                            <li className="flex items-start gap-3">
                                                <span className="mt-1 h-2 w-2 rounded-full bg-purple-400" />
                                                <span>Assurez-vous que chaque zone stratégique dispose d'un point dédié.</span>
                                            </li>
                                            <li className="flex items-start gap-3">
                                                <span className="mt-1 h-2 w-2 rounded-full bg-purple-400" />
                                                <span>Validez lorsque tous les points nécessaires sont définis.</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="rounded-2xl border border-purple-800/60 bg-black/50 p-6 shadow-[0_25px_80px_-50px_rgba(128,0,128,0.85)]">
                                        <div className="flex flex-col gap-4">
                                            <button
                                                onClick={handleValidatePoints}
                                                className={`w-full rounded-xl py-3 px-4 text-lg font-semibold transition ${points.length > 0 ? 'bg-gradient-to-r from-purple-600 via-red-600 to-purple-600 text-white shadow-lg hover:from-purple-500 hover:via-red-500 hover:to-purple-500' : 'bg-gray-800 text-gray-500 cursor-not-allowed'}`}
                                                disabled={points.length === 0}
                                            >
                                                Valider les points ({points.length})
                                            </button>
                                            <div className="overflow-hidden rounded-2xl border border-purple-900/40 bg-gray-950/80">
                                                <div className="max-h-64 overflow-y-auto">
                                                    <table className="min-w-full divide-y divide-purple-900/40 text-sm text-gray-200">
                                                        <thead className="bg-gray-900/80 text-xs uppercase tracking-[0.3em] text-purple-300">
                                                        <tr>
                                                            <th className="px-4 py-3 text-left">#</th>
                                                            <th className="px-4 py-3 text-left">Latitude</th>
                                                            <th className="px-4 py-3 text-left">Longitude</th>
                                                            <th className="px-4 py-3 text-center">Actions</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody className="divide-y divide-purple-900/30 bg-black/40">
                                                        {points.map((point, index) => (
                                                            <tr key={index} className="transition hover:bg-purple-900/20">
                                                                <td className="px-4 py-2 font-semibold text-purple-200">{index + 1}</td>
                                                                <td className="px-4 py-2 text-gray-300">{point.lat.toFixed(5)}</td>
                                                                <td className="px-4 py-2 text-gray-300">{point.lng.toFixed(5)}</td>
                                                                <td className="px-4 py-2 text-center">
                                                                    <button
                                                                        onClick={() => handleMarkerClick(index)}
                                                                        className="inline-flex items-center justify-center rounded-lg border border-red-500/60 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-red-300 transition hover:bg-red-600/20"
                                                                    >
                                                                        Supprimer
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {points.length === 0 && (
                                                            <tr>
                                                                <td colSpan={4} className="px-4 py-6 text-center text-gray-500">
                                                                    Aucun point ajouté
                                                                </td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </aside>
                            </div>
                        </section>
                    )}

                    {!gameState.isGameStarted && !gameState.questionsDefined && gameState.GpsDefined && gameState.rolesDefined && (
                        <section className="relative overflow-hidden rounded-3xl border border-purple-900/70 bg-gradient-to-br from-gray-950 via-gray-900 to-black p-8 shadow-[0_40px_120px_-45px_rgba(128,0,128,0.85)]">
                            <div className="pointer-events-none absolute -top-24 -right-20 h-64 w-64 rounded-full bg-purple-600/30 blur-3xl" />
                            <div className="pointer-events-none absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-red-500/20 blur-3xl" />

                            <div className="relative z-10 space-y-6">
                                <div className="space-y-3">
                <span className="inline-flex items-center gap-2 rounded-full border border-purple-500/40 bg-purple-500/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.3em] text-purple-200">
                    Phase Questions
                </span>
                                    <h2 className="text-3xl font-bold text-purple-100">
                                        Définissez les questions du jeu
                                    </h2>
                                    <p className="max-w-xl text-sm leading-relaxed text-gray-400">
                                        Créez les questions que les joueurs devront résoudre. Vous pouvez sauvegarder et charger des ensembles de questions pour les réutiliser.
                                    </p>
                                </div>

                                <div className="flex items-center gap-3 rounded-2xl border border-purple-700/60 bg-black/40 px-5 py-4 shadow-inner">
                                    <div className="text-4xl font-bold text-purple-300">{questions.length}</div>
                                    <div className="text-xs uppercase tracking-[0.25em] text-gray-400">
                                        Question{questions.length > 1 ? 's' : ''}<br />
                                        définie{questions.length > 1 ? 's' : ''}
                                    </div>
                                </div>

                                <div className="overflow-hidden rounded-2xl border border-purple-900/40 bg-gray-950/80 shadow-[0_25px_80px_-50px_rgba(128,0,128,0.85)]">
                                    <div className="max-h-96 overflow-y-auto">
                                        <table className="min-w-full divide-y divide-purple-900/40 text-sm text-gray-200">
                                            <thead className="sticky top-0 bg-gray-900/80 text-xs uppercase tracking-[0.3em] text-purple-300">
                                            <tr>
                                                <th className="px-4 py-3 text-left">Question</th>
                                                <th className="px-4 py-3 text-left">Réponse</th>
                                                <th className="px-4 py-3 text-center">Action</th>
                                            </tr>
                                            </thead>
                                            <tbody className="divide-y divide-purple-900/30 bg-black/40">
                                            {questions.map((question, index) => (
                                                <tr key={index} className="transition hover:bg-purple-900/20">
                                                    <td className="px-4 py-2">
                                                        <input
                                                            type="text"
                                                            value={question.question}
                                                            onChange={(e) => handleQuestionChange(index, e.target.value)}
                                                            className="w-full rounded-lg border border-purple-800/40 bg-gray-950/60 px-3 py-2 text-gray-200 placeholder-gray-500 transition focus:border-purple-500/60 focus:outline-none focus:ring-2 focus:ring-purple-500/20"
                                                            placeholder="Entrez la question..."
                                                        />
                                                    </td>
                                                    <td className="px-4 py-2">
                                                        <input
                                                            type="text"
                                                            value={question.answer}
                                                            onChange={(e) => handleQuestionAnswerChange(index, e.target.value)}
                                                            className="w-full rounded-lg border border-purple-800/40 bg-gray-950/60 px-3 py-2 text-gray-200 placeholder-gray-500 transition focus:border-purple-500/60 focus:outline-none focus:ring-2 focus:ring-purple-500/20"
                                                            placeholder="Entrez la réponse..."
                                                        />
                                                    </td>
                                                    <td className="px-4 py-2 text-center">
                                                        <button
                                                            onClick={() => handleQuestionDelete(index)}
                                                            className="inline-flex items-center justify-center rounded-lg border border-red-500/60 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-red-300 transition hover:bg-red-600/20"
                                                        >
                                                            Supprimer
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {questions.length === 0 && (
                                                <tr>
                                                    <td colSpan={3} className="px-4 py-6 text-center text-gray-500">
                                                        Aucune question ajoutée
                                                    </td>
                                                </tr>
                                            )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="border-t border-purple-900/40 bg-gray-900/60 px-4 py-3 text-center">
                                        <button
                                            onClick={() => setQuestions(prev => [...prev, { question: '', answer: '' }])}
                                            className="inline-flex items-center gap-2 rounded-xl border border-green-500/60 bg-green-600/10 px-4 py-2 text-sm font-semibold text-green-300 transition hover:bg-green-600/20"
                                        >
                                            <span className="text-lg">+</span>
                                            Ajouter une question
                                        </button>
                                    </div>
                                </div>

                                <div className="rounded-2xl border border-purple-800/60 bg-black/50 p-6 shadow-[0_25px_80px_-50px_rgba(128,0,128,0.85)]">
                                    <h3 className="text-lg font-semibold text-purple-200 mb-4">Gestion des ensembles de questions</h3>

                                    <div className="flex flex-wrap gap-3">
                                        <button
                                            onClick={handleSaveQuestions}
                                            className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${questions.length > 0 ? 'border border-green-500/60 bg-green-600/10 text-green-300 hover:bg-green-600/20' : 'border border-gray-700 bg-gray-800/50 text-gray-500 cursor-not-allowed'}`}
                                            disabled={questions.length === 0}
                                        >
                                            Sauvegarder cet ensemble
                                        </button>

                                        <div className="flex-grow min-w-[200px]">
                                            <select
                                                className="w-full rounded-xl border border-purple-800/40 bg-gray-950/60 px-3 py-2 text-gray-200 transition focus:border-purple-500/60 focus:outline-none focus:ring-2 focus:ring-purple-500/20"
                                                value={selectedQuestionSet}
                                                onChange={(e) => setSelectedQuestionSet(e.target.value)}
                                            >
                                                <option value="">Sélectionner un ensemble...</option>
                                                {questionSets.map((set) => (
                                                    <option key={set.id} value={set.name}>{set.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <button
                                            onClick={handleLoadQuestions}
                                            className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${selectedQuestionSet ? 'border border-blue-500/60 bg-blue-600/10 text-blue-300 hover:bg-blue-600/20' : 'border border-gray-700 bg-gray-800/50 text-gray-500 cursor-not-allowed'}`}
                                            disabled={!selectedQuestionSet}
                                        >
                                            Charger
                                        </button>

                                        <button
                                            onClick={handleDeleteQuestionSet}
                                            className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${selectedQuestionSet ? 'border border-red-500/60 bg-red-600/10 text-red-300 hover:bg-red-600/20' : 'border border-gray-700 bg-gray-800/50 text-gray-500 cursor-not-allowed'}`}
                                            disabled={!selectedQuestionSet}
                                        >
                                            Supprimer
                                        </button>
                                    </div>
                                </div>

                                {showSaveModal && (
                                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
                                        <div className="relative w-full max-w-md overflow-hidden rounded-3xl border border-purple-800/60 bg-gradient-to-br from-gray-950 via-gray-900 to-black p-8 shadow-[0_40px_120px_-45px_rgba(128,0,128,0.85)]">
                                            <div className="pointer-events-none absolute -top-16 -right-16 h-48 w-48 rounded-full bg-purple-600/30 blur-3xl" />
                                            <div className="relative z-10 space-y-6">
                                                <h3 className="text-2xl font-bold text-purple-100">Sauvegarder les questions</h3>

                                                <div className="space-y-2">
                                                    <label className="block text-sm font-medium text-gray-300">
                                                        Nom de l'ensemble
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={saveSetName}
                                                        onChange={(e) => setSaveSetName(e.target.value)}
                                                        className="w-full rounded-xl border border-purple-800/40 bg-gray-950/60 px-4 py-3 text-gray-200 placeholder-gray-500 transition focus:border-purple-500/60 focus:outline-none focus:ring-2 focus:ring-purple-500/20"
                                                        placeholder="Ex: Questions Faciles"
                                                    />
                                                </div>

                                                <div className="flex justify-end gap-3">
                                                    <button
                                                        onClick={() => setShowSaveModal(false)}
                                                        className="rounded-xl border border-gray-700 bg-gray-800/50 px-5 py-2 text-sm font-semibold text-gray-300 transition hover:bg-gray-700/50"
                                                    >
                                                        Annuler
                                                    </button>
                                                    <button
                                                        onClick={confirmSaveQuestions}
                                                        className={`rounded-xl px-5 py-2 text-sm font-semibold transition ${saveSetName.trim() ? 'bg-gradient-to-r from-green-600 to-green-500 text-white shadow-lg hover:from-green-500 hover:to-green-400' : 'border border-gray-700 bg-gray-800/50 text-gray-500 cursor-not-allowed'}`}
                                                        disabled={!saveSetName.trim()}
                                                    >
                                                        Sauvegarder
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <button
                                    onClick={handleValidateQuestions}
                                    className={`w-full rounded-xl py-4 px-4 text-lg font-semibold transition ${questions.length > 0 ? 'bg-gradient-to-r from-purple-600 via-red-600 to-purple-600 text-white shadow-lg hover:from-purple-500 hover:via-red-500 hover:to-purple-500' : 'bg-gray-800 text-gray-500 cursor-not-allowed'}`}
                                    disabled={questions.length === 0}
                                >
                                    Valider les questions ({questions.length})
                                </button>
                            </div>
                        </section>
                    )}

                    {gameState.isGameStarted && <div className="mt-4 space-x-2">
                        <button
                            onClick={() => socket.emit('end_game')}
                            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                        >
                            Terminer la partie
                        </button>
                        <button
                            onClick={handleForceGPSUpdate}
                            className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
                        >
                            Forcer mise à jour GPS
                        </button>
                        {!gameState.manhunt && <button
                            onClick={() => socket.emit('force-manhunt')}
                            className="px-4 py-2 bg-red-700 text-white rounded hover:bg-red-800 font-semibold animate-pulse"
                        >
                            🚨 Déclencher chasse à l'homme
                        </button>}
                    </div>}

                    {!gameState.isGameStarted && gameState.rolesDefined && gameState.GpsDefined && gameState.questionsDefined &&
                        <button
                            onClick={() => socket.emit('start_game')}
                            className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                        >
                            Démarrer la partie
                        </button>}

                    {gameState.reunionAsked && <button
                        onClick={() => socket.emit('end_reunion')}
                        className="mt-4 px-4 py-2 bg-green-950 text-white rounded hover:bg-green-800"
                    >
                        Fin de la réunion
                    </button>
                    }
                </div>
            </div>
        </div>);

}